import { create } from 'zustand';

const initialArticleState = {
  id: null,
  slug: null,
  autosave_token: null,
  title_id: '',
  title_en: '',
  content_id: '',
  content_en: '',
  ownerable_id: '',
  doctor_id: '',
  doctor_name: '',
  doctor_avatar: null,
  image: null,
  image_url: null,
  remove_image: false,
  meta_description: '',
  meta_keywords: '',
  tag_list: [],
  category_list: [],
  published: false,
  has_publish_record: false,
  updated_at: null
};

const useArticleStore = create((set, get) => ({
  ...initialArticleState,

  // Autosave status
  saveStatus: 'idle', // idle | saving | saved | error
  lastSavedAt: null,
  publishErrors: {},

  // Dirty tracking
  _lastSavedState: null,

  resetStore: () => {
    set({ ...initialArticleState, saveStatus: 'idle', lastSavedAt: null, publishErrors: {}, _lastSavedState: null });
  },

  setArticle: (article) => {
    const state = { ...initialArticleState, ...article };
    set({ ...state, _lastSavedState: state });
  },

  updateField: (field, value) => {
    set({ [field]: value });
  },

  updateFields: (fields) => {
    set(fields);
  },

  setSaveStatus: (status) => {
    set({ saveStatus: status });
    if (status === 'saved') {
      set({ lastSavedAt: new Date() });
    }
  },

  markSaved: (newToken) => {
    const current = get();
    const savedState = {};
    Object.keys(initialArticleState).forEach(key => {
      savedState[key] = current[key];
    });
    set({
      autosave_token: newToken,
      saveStatus: 'saved',
      lastSavedAt: new Date(),
      _lastSavedState: savedState
    });
  },

  setPublishErrors: (errors) => {
    set({ publishErrors: errors });
  },

  getChangedFields: () => {
    const current = get();
    const lastSaved = current._lastSavedState || initialArticleState;

    const changed = {};
    Object.keys(initialArticleState).forEach(key => {
      if (key === 'image' && current[key] instanceof File) {
        changed[key] = current[key];
      } else if (JSON.stringify(current[key]) !== JSON.stringify(lastSaved[key])) {
        changed[key] = current[key];
      }
    });
    return changed;
  },

  hasUnsavedChanges: () => {
    const current = get();
    const lastSaved = current._lastSavedState || initialArticleState;

    return Object.keys(initialArticleState).some(key => {
      if (key === 'image' && current[key] instanceof File) return true;
      return JSON.stringify(current[key]) !== JSON.stringify(lastSaved[key]);
    });
  }
}));

export default useArticleStore;
